function getUrlParams(){
  let typeStr = window.location.search, params = { }
  if(typeStr.indexOf('?')>=0 && typeStr.slice(1)){
      let paramsArr = typeStr.slice(1).split('&')
      paramsArr.forEach((item)=>{
          if(item){
              params[item.split('=')[0]] = decodeURIComponent(item.split('=')[1])
          }
      })
  }
  return params
}
